/**

 * @作者 王

 * @创建于 2021/3/1 15:58

 */
import {post,fetch,downloadPost} from "./axios";
import {BASE_IDS_URL, BASE_SYS_URL, BASE_OSS_URL, BASE_BPM_URL} from "./baseModelUrl";
// 对象存储
export const uploadApi = BASE_OSS_URL + '/files/uploadFile';

// 获取文件查看路径
export const getImgURLApi  = (json)=>{
    const url = BASE_OSS_URL + '/files/openFile';
    return post(url,json)
};
// 附件下载
export const downFileApi  = (json)=>{
    const url = BASE_OSS_URL + '/files/downFile';
    return downloadPost(url,json)
};

export const loginApi  = (json)=>{
    const url = BASE_IDS_URL + '/account/login';
    return post(url,json,{headers:{
            "x-skip-filter" : "123123"
        }})
}
//=======================人员============================//
// 获取参与人下级下拉
export const getUserListByDepForSelectApi  = (json)=>{
    const url = BASE_IDS_URL + '/user/getUserListByDepForSelect';
    return post(url,json)
};

// 获取人员下级下拉
export const getAvailableUserByPageApi  = (json)=>{
    const url = BASE_IDS_URL + '/user/getAvailableUserByPage';
    return post(url,json)
};

//=======================部门============================//
// 获取部门下级下拉
export const getDepListForSelectApi  = (json)=>{
    const url = BASE_IDS_URL + '/dep/getAvailableDepListForOption';
    return post(url,json)
};
// 获取部门下拉
export const getDepListForOptionApi  = (json)=>{
    const url = BASE_IDS_URL + '/dep/getAvailableDepListForOption ';
    return post(url,json)
};

// 获取部门列表
export const getDepartmentListApi  = (json)=>{
    const url = BASE_IDS_URL + '/dep/getDepList';
    return post(url,json)
};

// 根据Id获取部门详情
export const getDepartmentApi  = (id)=>{
    const url = BASE_IDS_URL + '/dep/getDep/'+id;
    return post(url)
};

// 新增部门
export const addDepartmentApi  = (json)=>{
    const url = BASE_IDS_URL + '/dep/addDep';
    return post(url,json)
};

// 更新部门
export const updateDepartmentApi  = (json)=>{
    const url = BASE_IDS_URL + '/dep/updateDep';
    return post(url,json)
};

// 删除部门
export const deleteDepartmentListApi  = (json)=>{
    const url = BASE_IDS_URL + '/dep/deleteDep ';
    return post(url,json)
};

//=======================单位============================

// 获取单位列表
export const getUnitSelectListApi  = (json)=>{
    const url = BASE_IDS_URL + '/unit/getAvailableUnitListForOption';
    return post(url,json)
};

// 获取单位列表
export const getUnitListApi  = (json)=>{
    const url = BASE_IDS_URL + '/unit/getUnitList';
    return post(url,json)
};

// 根据Id获取单位详情
export const getUnitApi  = (id)=>{
    const url = BASE_IDS_URL + '/unit/getUnit/'+id;
    return post(url)
};

// 新增单位
export const addUnitApi  = (json)=>{
    const url = BASE_IDS_URL + '/unit/addUnit';
    return post(url,json)
};

// 更新单位
export const updateUnitApi  = (json)=>{
    const url = BASE_IDS_URL + '/unit/updateUnit';
    return post(url,json)
};

// 删除单位
export const deleteUnitListApi  = (json)=>{
    const url = BASE_IDS_URL + '/unit/deleteUnit ';
    return post(url,json)
};


//=======================机构============================

// 获取机构option列表
export const getInstitutionalForSelectApi  = (json)=>{
    const url = BASE_IDS_URL + '/institutional/getInstitutionalListForOptions';
    return post(url,json)
};

// 获取机构列表
export const getInstitutionalListApi  = (json)=>{
    const url = BASE_IDS_URL + '/institutional/getInstitutionalList';
    return post(url,json)
};

// 根据Id获取机构详情
export const getInstitutionalApi  = (id)=>{
    const url = BASE_IDS_URL + '/institutional/getInstitutional/'+id;
    return post(url)
};

// 新增机构
export const addInstitutionalApi  = (json)=>{
    const url = BASE_IDS_URL + '/institutional/addInstitutional';
    return post(url,json)
};

// 更新机构
export const updateInstitutionalApi  = (json)=>{
    const url = BASE_IDS_URL + '/institutional/updateInstitutional';
    return post(url,json)
};

// 删除机构
export const deleteInstitutionalListApi  = (json)=>{
    const url = BASE_IDS_URL + '/institutional/deleteInstitutional ';
    return post(url,json)
};


//=======================菜单============================

// 获取菜单列表
export const getMenuListApi  = (json)=>{
    const url = BASE_IDS_URL + '/menu/getMenuList';
    return post(url,json)
};

// 根据Id获取菜单详情
export const getMenuApi  = (id)=>{
    const url = BASE_IDS_URL + '/menu/getMenu/'+id;
    return post(url)
};

// 新增菜单
export const addMenuApi  = (json)=>{
    const url = BASE_IDS_URL + '/menu/addMenu';
    return post(url,json)
};

// 更新菜单
export const updateMenuApi  = (json)=>{
    const url = BASE_IDS_URL + '/menu/updateMenu';
    return post(url,json)
};

// 删除菜单
export const deleteMenuListApi  = (json)=>{
    const url = BASE_IDS_URL + '/menu/deleteMenu ';
    return post(url,json)
};

//=======================权限============================

// 获取权限列表
export const getPermissionListApi  = (json)=>{
    const url = BASE_IDS_URL + '/permission/getPermissionList';
    return post(url,json)
};
// 获取权限列表
export const getPermissionListByRoleApi  = (id)=>{
    const url = BASE_IDS_URL + '/rolePermission/getRolePermissionByRole/'+id;
    return post(url)
};
// 获取角色权限
export const getRolePermissionByRole  = (id)=>{
    const url = BASE_IDS_URL + '/rolePermission/getRolePermissionByRole/'+id;
    return post(url)
};
// 根据Id获取权限详情
export const getPermissionApi  = (id)=>{
    const url = BASE_IDS_URL + '/permission/getPermission/'+id;
    return post(url)
};

// 新增权限
export const addPermissionApi  = (json)=>{
    const url = BASE_IDS_URL + '/permission/addPermission';
    return post(url,json)
};

// 更新权限
export const updatePermissionApi  = (json)=>{
    const url = BASE_IDS_URL + '/permission/updatePermission';
    return post(url,json)
};

// 删除权限
export const deletePermissionListApi  = (json)=>{
    const url = BASE_IDS_URL + '/permission/deletePermission ';
    return post(url,json)
};

//=======================角色============================

// 获取角色列表
export const getRoleListApi  = (json)=>{
    const url = BASE_IDS_URL + '/role/getRoleList';
    return post(url,json)
};
//根据id获取角色菜单
export const getMenuTree   = (id)=>{
    const url = BASE_IDS_URL + '/menu/getMenuTree';
    return post(url)
};
// 根据Id获取角色详情
export const getRoleApi  = (id)=>{
    const url = BASE_IDS_URL + '/role/getRole/'+id;
    return post(url)
};

// 新增角色
export const addRoleApi  = (json)=>{
    const url = BASE_IDS_URL + '/role/addRole';
    return post(url,json)
};

// 更新角色
export const updateRoleApi  = (json)=>{
    const url = BASE_IDS_URL + '/role/updateRole';
    return post(url,json)
};
//更新角色权限
export const updateRolePermission  = (json)=>{
    const url = BASE_IDS_URL + '/rolePermission/updateRolePermission';
    return post(url,json)
};
// 删除角色
export const deleteRoleListApi  = (json)=>{
    const url = BASE_IDS_URL + '/role/deleteRole ';
    return post(url,json)
};

//=======================标签============================

// 获取标签列表
export const getTagListApi  = (json)=>{
    const url = BASE_SYS_URL+ '/tag/getTagList';
    return post(url,json)
};

// 根据Id获取标签详情
export const getTagApi  = (id)=>{
    const url = BASE_SYS_URL+ '/tag/getTagById/'+id;
    return post(url)
};

// 新增标签
export const addTagApi  = (json)=>{
    const url = BASE_SYS_URL+ '/tag/addTag';
    return post(url,json)
};

// 更新标签
export const updateTagApi  = (json)=>{
    const url = BASE_SYS_URL+ '/tag/updateTag';
    return post(url,json)
};

// 删除标签
export const deleteTagListApi  = (json)=>{
    const url = BASE_SYS_URL+ '/tag/deleteTag ';
    return post(url,json)
};


//=======================字典============================

// 获取字典列表
export const getEnumItemListApi  = (json)=>{
    const url = BASE_SYS_URL+ '/enumItem/getEnumItemList';
    return post(url,json)
};

// 根据Id获取字典详情
export const getEnumItemApi  = (id)=>{
    const url = BASE_SYS_URL+ '/enumItem/getEnumItemById/'+id;
    return post(url)
};

// 新增字典
export const addEnumItemApi  = (json)=>{
    const url = BASE_SYS_URL+ '/enumItem/addEnumItem';
    return post(url,json)
};

// 更新字典
export const updateEnumItemApi  = (json)=>{
    const url = BASE_SYS_URL+ '/enumItem/updateEnumItem';
    return post(url,json)
};

// 删除字典
export const deleteEnumItemListApi  = (json)=>{
    const url = BASE_SYS_URL+ '/enumItem/deleteEnumItem ';
    return post(url,json)
};

//=======================节假日============================

// 获取节假日列表
export const getHolidayListApi  = (json)=>{
    const url = BASE_SYS_URL+ '/holiday/getHolidayList';
    return post(url,json)
};

// 根据Id获取节假日详情
export const getHolidayApi  = (id)=>{
    const url = BASE_SYS_URL+ '/holiday/getHolidayById/'+id;
    return post(url)
};

// 新增节假日
export const addHolidayApi  = (json)=>{
    const url = BASE_SYS_URL+ '/holiday/addHoliday';
    return post(url,json)
};

// 更新节假日
export const updateHolidayApi  = (json)=>{
    const url = BASE_SYS_URL+ '/holiday/updateHoliday';
    return post(url,json)
};

// 删除节假日
export const deleteHolidayListApi  = (json)=>{
    const url = BASE_SYS_URL+ '/holiday/deleteHoliday ';
    return post(url,json)
};

//=======================字典============================

//根据Code获取字典接口
export const getEnumListByCodeApi = (code) => {
    let json = {
        moduleCode: code
    };
    const url = BASE_SYS_URL + '/enumItem/getEnumItemJson';
    return post(url, json)
};
export const getNowUserPermissionApi = ()=>{
    const url = BASE_IDS_URL + '/permission/getLoginUserAllPagePermission';
    return post((url))
};



//=======================日志============================

export const getLogListApi = (json)=>{
    const url = BASE_SYS_URL + '/audit/getAuditLogInfoList';
    return post(url,json)
};
export const getLogDetailApi = (id)=>{
    const url = BASE_SYS_URL + '/audit/getOperationLogsById/'+id;
    return post((url))
};


//=======================站点============================

// 获取站点列表
export const getSiteListApi  = (json)=>{
    const url = BASE_IDS_URL+ '/site/getSiteList';
    return post(url,json)
};

// 根据Id获取站点详情
export const getSiteApi  = (id)=>{
    const url = BASE_IDS_URL+ '/site/getSite/'+id;
    return post(url)
};

// 新增站点
export const addSiteApi  = (json)=>{
    const url = BASE_IDS_URL+ '/site/addSite';
    return post(url,json)
};

// 更新站点
export const updateSiteApi  = (json)=>{
    const url = BASE_IDS_URL+ '/site/updateSite';
    return post(url,json)
};

// 删除站点
export const deleteSiteListApi  = (json)=>{
    const url = BASE_IDS_URL+ '/site/deleteSite';
    return post(url,json)
};

